export default __webpack_public_path__ + "media/logo-vlgi-vida.png";